//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/**
 * Filters for formatting addresses given an object containing address-like fields
 *
 * oneLineAddress:
 *  Returns an address including street, city, state, and zip. Fields are omitted when they are not present
 *  The output is returned as a string, so this can be used with interpolaton or ng-bind
 *
 *  Example Usage:
 *      <span class="address">{{ location | oneLineAddress }}</span>
 *      <span class="address" ng-bind="location | oneLineAddress"><span>
 *
 * twoLineAddress:
 *   Returns an address HTML string, which wraps to a newline and includes street, city, state, and zip.
 *   Fields are omitted when they are not present
 *
 *   The output is returned as an HTML string, so binding must take place using ng-bind-html
 *
 *   Example Usage:
 *      <span class="address" ng-bind-html="location | twoLineAddress"></span>
 */
(function() {
  angular.module('curalate')
        .filter('oneLineAddress',
            () => function(input) {
              let finalString;

              if (!angular.isObject(input)) {
                return '';
              }

              const streetCity = (input.street ? `${input.street}, ` : '') + (input.city ? `${input.city}, ` : '');
              const stateZip = (input.state ? input.state.toUpperCase() : '') + (input.zip ? ` ${input.zip}` : '');
              finalString = (`${streetCity}${stateZip}`).trim();
              if (finalString.charAt(finalString.length - 1) === ',') {
                finalString = finalString.substring(0, finalString.length - 1);
              }

              return finalString;
            },
        ).filter('twoLineAddress', [
          '$sce',
          function($sce) {
            return function(input) {
              let finalString;

              if (!angular.isObject(input)) {
                return '';
              }

              const address = (input.street ? `${input.street}<br />` : '') +
                        (input.city ? `${input.city}, ` : '') +
                        (input.state ? `${input.state} ` : '');
              const fullAddress = (`${address}` && input.zip ? address + input.zip : address);  // Add the zip if it's defined and there's an address.
              finalString = fullAddress.trim();

              if (finalString.charAt(finalString.length - 1) === ',') {
                finalString = finalString.substring(0, finalString.length - 1);
              }

              return $sce.trustAsHtml(finalString);
            };
          },
        ]);
})();
